export type UpCareStat = {
    id: string;
    label: string;
    rawValue?: number;
    percent?: number;
    displayValue?: number;
    suffix: string;
};

const getStratifierValue = (
    measureReport: any,
    stratifierId: string
): number | undefined => {
    const stratifier = measureReport.group?.[0]?.stratifier?.find(
        (item: any) => item.id === stratifierId
    );

    const value = stratifier?.stratum?.[0]?.value?.text;

    if (value === undefined || value === null || value === "") {
        return undefined;
    }

    const numericValue = Number(value);

    if (!Number.isFinite(numericValue)) {
        return undefined;
    }

    return numericValue;
};

const buildPercentStat = (
    measureReport: any,
    id: string,
    label: string,
    maxScore: number
): UpCareStat => {
    const rawValue = getStratifierValue(measureReport, id);

    if (rawValue === undefined) {
        return {
            id,
            label,
            suffix: "%"
        };
    }

    const percent = Math.round((rawValue / maxScore) * 100);

    return {
        id,
        label,
        rawValue,
        percent,
        displayValue: percent,
        suffix: "%"
    };
};

export const mapUpCareMeasureReportToStats = (
    measureReport: any,
    maxScore = 10
): UpCareStat[] => {
    const engagement = buildPercentStat(
        measureReport,
        "average-engagement",
        "Engagement",
        maxScore
    );

    const faireEquipe = buildPercentStat(
        measureReport,
        "average-faire-equipe",
        "Faire équipe",
        maxScore
    );

    const bienveillance = buildPercentStat(
        measureReport,
        "average-bienveillance",
        "Bienveillance",
        maxScore
    );

    const respect = buildPercentStat(
        measureReport,
        "average-respect",
        "Respect",
        maxScore
    );

    return [
        engagement,
        faireEquipe,
        bienveillance,
        respect
    ];
};